import React, { Component } from 'react';
import AggBin from './AggBin';
import SiloBin from './SiloBin';
import WaterBin from './WaterBin';
import {
  inject,
  observer,
} from 'mobx-react';
import { WeighedMaterialType } from '../../../constants/MaterialModels';
import deviceDOMHoc from '../../../hocs/deviceDOMHoc';
import { IconBinList } from '../../../constants/DeviceModels';
import BinScrew from './BinScrew';
import { deferFeedBin } from '../../../stores/batch/defer-feed-bin';
import { DeviceStatus } from '../../../constants/DeviceStatus';

@inject('materialStore', 'batchStore', 'settingsStore', 'devicesStore')
@observer
class Bin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      continuousPressActive: false,
    };
  }

  startContinuousPressProgress = () => {
    this.setState({ continuousPressActive: true });
  };

  stopContinuousPressProgress = () => {
    this.setState({ continuousPressActive: false });
  };

  isContinuousPressActive = () => {
    return this.state.continuousPressActive;
  };

  render() {
    const { device, materialStore, batchStore, devicesStore } = this.props;
    const material = materialStore.getMaterialForBin(device.id);
    const materialDetails = material ? materialStore.materialDetails[material.materialDetailId] : null;
    const materialType = materialDetails ? materialDetails.type : null;
    const isBinForMultiScale = devicesStore.isBinActiveForMultiScale(device.id, material);
    const numberOfDeferredDevicesForScale = batchStore.getNumberOfDeferredDevicesForScale(device.scaleId);
    const deviceStatus = batchStore.getDeviceStatus(device.id);
    const scaleId = device?.scaleId;
    const runningData = batchStore.running.find((runningData) =>
      runningData.uid === deviceStatus.uid && runningData.currentDrop === deviceStatus.currentDrop,
    );
    const currentScaleData = runningData?.scales[scaleId];
    const currentWeighedDataToBatch = currentScaleData?.find(v => v.material.itemId === material?.itemId);
    const hasBeenSubstituted = currentWeighedDataToBatch
      ? currentWeighedDataToBatch.isSubstituted
      : deviceStatus.isSubstituted;
    const substitutionWeight = currentWeighedDataToBatch
      ? currentWeighedDataToBatch.substitutionWeight
      : deviceStatus.substitutionWeight || 0;

    const isDeferFeedDisabled = (
      // For now, we don't allow to defer feed if there are other bins that are deferred for the same scale
      numberOfDeferredDevicesForScale > 0 ||
      // Don't allow to defer if there's only one weighed data in the scale
      (currentScaleData && currentScaleData.length === 1) ||
      deviceStatus.status !== DeviceStatus.HOLD
    );

    const onPush = () => {
      batchStore.onBinButtonDown(device.id);

      // Check if device is jogging to start continuous press progress
      const binStatus = batchStore.getDeviceStatus(device.id);
      const isJogging = binStatus.status === DeviceStatus.JOG ||
        (binStatus.status === DeviceStatus.SETTLING && binStatus.prevStatus === DeviceStatus.JOG);

      if (isJogging) {
        this.startContinuousPressProgress();
      }

      return batchStore.onBinButtonPress(device);
    };

    const onPushUp = () => {
      batchStore.onBinButtonUp(device.id);
      this.stopContinuousPressProgress(); // Stop progress when button is released
      return batchStore.onBinButtonRelease(device);
    };

    const holdFeed = (e) => {
      if (!batchStore.canSendRemoteInstruction()) {
        e.stopPropagation();
      }
      batchStore.setFeedInterruption(device.id);
      return batchStore.onPausePlayFeedButtonPress(device.id);
    };

    const deferFeed = (e) => {
      if (!batchStore.canSendRemoteInstruction()) {
        e.stopPropagation();
      }
      deferFeedBin(batchStore.rootStore, device.id);
    };

    const finishFeed = (e, material) => {
      e.stopPropagation();
      return batchStore.onFinishFeedButtonPress(device.id, material);
    };

    if (device.hide) {
      return '';
    }

    if (device.icon === IconBinList.SCREW) {
      return (
        <BinScrew material={material} materialDetails={materialDetails} {...this.props} onPush={onPush}
          onPushUp={onPushUp} holdFeed={holdFeed} finishFeed={finishFeed} isBinForMultiScale={isBinForMultiScale} />
      );
    }

    if (materialType === WeighedMaterialType.Water || materialType === WeighedMaterialType.SecondWater) {
      return (
        <WaterBin material={material} materialDetails={materialDetails} {...this.props} onPush={onPush}
          onPushUp={onPushUp} holdFeed={holdFeed} finishFeed={finishFeed} isBinForMultiScale={isBinForMultiScale} />
      );
    }

    if (materialType === WeighedMaterialType.Cement || materialType === WeighedMaterialType.Cementitious) {
      return (
        <SiloBin
          material={material}
          materialDetails={materialDetails}
          {...this.props}
          onPush={onPush}
          onPushUp={onPushUp}
          holdFeed={holdFeed}
          finishFeed={finishFeed}
          isBinForMultiScale={isBinForMultiScale}
          deferFeed={deferFeed}
          isDeferFeedDisabled={isDeferFeedDisabled}
          hasBeenSubstituted={hasBeenSubstituted}
          substitutionWeight={substitutionWeight}
        />
      );
    }

    return (
      <AggBin
        material={material}
        materialDetails={materialDetails}
        {...this.props}
        onPush={onPush}
        onPushUp={onPushUp}
        holdFeed={holdFeed}
        finishFeed={finishFeed}
        isBinForMultiScale={isBinForMultiScale}
        deferFeed={deferFeed}
        isDeferFeedDisabled={isDeferFeedDisabled}
        isContinuousPressActive={this.isContinuousPressActive()}
        hasBeenSubstituted={hasBeenSubstituted}
        substitutionWeight={substitutionWeight}
      />
    );

  }
}

export default deviceDOMHoc(Bin);
